import axios from 'axios'

export default {
  /**
   * Get all active payment terms (public - for dropdowns)
   */
  getAll() {
    return axios.get('/api/payment-terms')
  },

  /**
   * Get all payment terms (admin)
   */
  getAllAdmin() {
    return axios.get('/api/admin/payment-terms')
  },

  /**
   * Get a single payment term
   */
  getById(id) {
    return axios.get(`/api/admin/payment-terms/${id}/show`)
  },

  /**
   * Create a new payment term
   */
  create(data) {
    return axios.post('/api/admin/payment-terms', data)
  },

  /**
   * Update a payment term
   */
  update(id, data) {
    return axios.patch(`/api/admin/payment-terms/${id}/update`, data)
  },

  /**
   * Delete a payment term
   */
  delete(id) {
    return axios.delete(`/api/admin/payment-terms/${id}/destroy`)
  },

  /**
   * Update sort order for payment terms
   */
  updateOrder(ids) {
    return axios.post('/api/admin/payment-terms/update-order', { ids })
  }
}
